<template>
  <div id="dependent-data-form">
    <header v-if="showTitle" class="panel__header mt-2 mb-4">
      <h2 class="panel__title">SEUS DEPENDENTES:</h2>
    </header>

    <div class="row">
      <div class="col-12 col-sm-12">
        <div id="accordion" class="panel__content">
          <div
            v-for="(planodepentente, indexPlano) in dependentes"
            :key="indexPlano"
            class="card mb-4"
            style="border: none"
          >
            <div
              id="headingOne"
              class="cabecalhoDependente"
              data-toggle="collapse"
              :data-target="'#' + planodepentente.id"
              aria-expanded="true"
              :aria-controls="planodepentente.id"
            >
              <div class="card-header p-3" style="justify-content: flex-start">
                <div>
                  <h6 class="tituloDependentes" style="padding: 5px 0">
                    Dependente
                  </h6>
                  <h5 style="margin-bottom: 0px; font-weight: bold">{{ planodepentente.nome_display }}</h5>
                  <small style="font-size: 12px" v-html="descricaoPlaDep(planodepentente)"></small>
                </div>
              </div>

              <div
                :id="planodepentente.id"
                class="collapse show card-body"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div class="card-body">
                  <div
                    v-for="(dependente, index) in planodepentente.dependentes"
                    style="padding: 0px"
                    :key="index"
                  >
                    <div
                      :id="`div` + planodepentente.id + index"
                      v-bind:style="{ display: displayDep(index) }"
                    >
                      <div>
                        <h6 class="tituloDependentes">
                          Dependente {{ index + 1 }}
                        </h6>
                      </div>

                      <div class="row" v-if="planodepentente.tipo == 'X'">
                        <p class="col-12">
                          <input
                            data-vv-as="Nome Completo"
                            v-validate="'required|alpha_spaces'"
                            :class="{
                              'is-invalid': errors.has(
                                'nomeCompleto_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'nomeCompleto_' + indexPlano + '_' + index"
                            type="text"
                            class="form-control"
                            v-model="dependentes[indexPlano].dependentes[index].nomeCompleto"
                            placeholder="Nome Completo: João Paulo da Silva"
                            value=""
                          />

                          <span class="invalid-feedback">
                            {{
                              errors.first(
                                "nomeCompleto_" + indexPlano + "_" + index
                              )
                            }}
                          </span>
                        </p>
                      </div>

                      <div class="row" v-if="planodepentente.tipo != 'X'">
                        <p class="col-12 col-sm-7">
                          <input
                            data-vv-as="Nome Completo"
                            v-validate="'required|alpha_spaces'"
                            :class="{
                              'is-invalid': errors.has(
                                'nomeCompleto_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'nomeCompleto_' + indexPlano + '_' + index"
                            type="text"
                            class="form-control"
                            v-model="dependentes[indexPlano].dependentes[index].nomeCompleto"
                            :disabled="dependentes[indexPlano].dependentes[index].pg == 'sim' || planodepentente.cadastro_no_admin != 0 || planodepentente.plus === 'Y' || planodepentente.plano_pai.congelado === 'Y'" 
                            placeholder="Nome Completo: João Paulo da Silva"
                            value=""
                          />

                          <span class="invalid-feedback">
                            {{
                              errors.first(
                                "nomeCompleto_" + indexPlano + "_" + index
                              )
                            }}
                          </span>
                        </p>
                        <p class="col-12 col-sm-5">
                          <input
                            data-vv-as="E-mail"
                            :class="{
                              'is-invalid': errors.has(
                                'email_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'email_' + indexPlano + '_' + index"
                            v-validate="'required|email'"
                            type="email"
                            class="form-control"
                            v-model="
                              dependentes[indexPlano].dependentes[index].email
                            "
                            :disabled="dependentes[indexPlano].dependentes[index].pg == 'sim' || planodepentente.cadastro_no_admin != 0 || planodepentente.plus === 'Y' || planodepentente.plano_pai.congelado === 'Y'" 
                            placeholder="E-mail: seuemail@xxxx.com.br"
                            value=""
                          />

                          <span class="invalid-feedback">
                            {{
                              errors.first("email_" + indexPlano + "_" + index)
                            }}
                          </span>
                        </p>
                      </div>

                      <div class="row" v-if="planodepentente.tipo != 'X'">
                        <p class="col-12 col-sm-4">
                          <masked-input
                            data-vv-as="CPF"
                            :class="{
                              'is-invalid': errors.has(
                                'cpf_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'cpf_' + indexPlano + '_' + index"
                            type="text"
                            class="form-control"
                            v-model="
                              dependentes[indexPlano].dependentes[index].cpf
                            "
                            :disabled="dependentes[indexPlano].dependentes[index].pg == 'sim' || planodepentente.cadastro_no_admin != 0 || planodepentente.plus === 'Y' || planodepentente.plano_pai.congelado === 'Y'" 
                            :mask="[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/,]"
                            v-on:keydown.delete="onDeleteMask"
                            @keyup="removeCPFError('cpf_' + indexPlano + '_' + index)" 
                            :guide="false"
                            placeholder="CPF: 000.000.000-00"
                          >
                          </masked-input>

                          <span class="invalid-feedback">
                            {{
                              errors.first("cpf_" + indexPlano + "_" + index)
                            }}
                          </span>
                        </p>
                        <p class="col-12 col-sm-4">
                          <input
                            @input="maybeDisplayAgeError(indexPlano, index)"
                            v-validate="{
                              required: true,
                              datanasc: ageErrors[`${indexPlano}_${index}_datanasc`],
                              idadecompat: ageErrors[`${indexPlano}_${index}_idadecompat`],
                            }"
                            type="text"
                            :name="'dataNascimento_' + indexPlano + '_' + index"
                            class="form-control"
                            :class="{
                              'is-invalid':
                                !isAgeAllowed(indexPlano, index, dependentes[indexPlano].dependentes[index].dataNascimento)
                                && errors.has('dataNascimento_' + indexPlano + '_' + index),
                            }"
                            v-model="dependentes[indexPlano].dependentes[index].dataNascimento"
                            :disabled="dependentes[indexPlano].dependentes[index].pg == 'sim' || planodepentente.cadastro_no_admin != 0 || planodepentente.plus === 'Y' || planodepentente.plano_pai.congelado === 'Y'" 
                            v-mask="[/\d/,/\d/,'/',/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/,]"
                            v-on:keydown.delete="onDeleteMask"
                            :guide="false"
                            placeholder="Data de Nascimento: DD/MM/AAAA"
                          />

                          <span class="invalid-feedback">
                            {{ errors.first("dataNascimento_" + indexPlano + "_" + index) }}
                          </span>
                        </p>

                        <p class="col-12 col-sm-4">
                          <select
                            data-vv-as="Sexo"
                            :class="{
                              'is-invalid': errors.has(
                                'sexo_' + indexPlano + '_' + index
                              ),
                            }"
                            :name="'sexo_' + indexPlano + '_' + index"
                            class="form-select"
                            v-model="dependentes[indexPlano].dependentes[index].sexo"
                            :disabled="dependentes[indexPlano].dependentes[index].pg == 'sim' || planodepentente.cadastro_no_admin != 0 || planodepentente.plus === 'Y' || planodepentente.plano_pai.congelado === 'Y'" 
                            v-validate="'required'"
                          >
                            <option value="" selected disabled>Sexo:</option>
                            <option value="M">Masculino</option>
                            <option value="F">Feminino</option>
                          </select>
                          <span class="invalid-feedback">
                            {{ errors.first("sexo_" + indexPlano + "_" + index) }}
                          </span>
                        </p>
                      </div>
                      <div
                        :id="'btnAddDep' + planodepentente.id + index"
                        v-if="planodepentente.plus !== 'Y' && index < planodepentente.dependentes.length - 1"
                        style="text-align: right; margin-top: 15px"
                      >
                        <button
                          v-on:click="
                            showNextDep(
                              'div' + planodepentente.id + (index + 1),
                              'btnAddDep' + planodepentente.id + index
                            )
                          "
                          type="button"
                          class="btn btn-primary"
                          style="border-radius: 50px"
                        >
                          <!-- data-bs-dismiss="modal" -->
                          <i class="fas fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-alert
          variant="danger"
          dismissible
          :show="error.show"
          v-model="error.show"
        >
          {{ error.text }}
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ValidaCPF from '../../utils/validators/Validators'

export default Vue.extend({
  data() {
    return {
      plusQuotaCount: 0,
      // TODO: Refactor
      allDependents: [],
      dependentKeys: [],
      ageErrors: {},
      error: {
        show: false,
        text: '',
      },
    }
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    dependentes: {
      required: true,
      type: Array
    },
    showTitle: {
      required: false,
      default: true,
      type: Boolean
    }
  },
  mounted() {
    // This is to make the birth date error messages work properly
    // Yep, it is a REALLY bad solution. Probably v-validate has a better one,
    // but not enough time to look for it atm.
    this.dependentes.forEach((plan, planIndex) => {
      plan.dependentes.forEach((dep, depIndex) => {
        dep.sexo = dep.sexo.substr(0, 1)
        dep.key = `${planIndex}_${depIndex}`
        this.ageErrors[`${dep.key}_datanasc`] = false
        this.ageErrors[`${dep.key}_idadecompat`] = false
        this.allDependents.push(dep)
      })
    })
  },
  methods: {
    // TODO: refactor
    descricaoPlaDep(plan){
      if(plan.detalhe_desc){
        return plan.detalhe_desc
      }

      const locale = window.locale.replace('_', '-')
      return `Parcelas a partir de ${this.$n(Number(plan.valor), 'currency', locale)}.`
    },
    // Todo: refactor
    displayDep(index) {
      if (index > 0) {
        return 'none'
      }

      return 'block'
    },
    isAgeAllowed(planIndex, depIndex, birthDate) {
      try {
      	const isInvalidDate = !window.luxon.fromFormat(birthDate, 'dd/MM/yyyy').isValid
        
        if (isInvalidDate) {
          this.ageErrors[`${planIndex}_${depIndex}_datanasc`] = isInvalidDate
          return false
        }
      } catch {
      	this.ageErrors[`${planIndex}_${depIndex}_datanasc`] = false
        return false
      }
      
      const birthYear = birthDate.split('/')[2]
      const currentYear = (new Date()).getFullYear()
      const min = this.dependentes[planIndex].idade_inicial
      const max = this.dependentes[planIndex].idade_final
      const age = currentYear - birthYear
      return (age >= min && age <= max)
    },
    maybeDisplayAgeError(planIndex, depIndex) {
      const birthDate = this.dependentes[planIndex].dependentes[depIndex].dataNascimento
      if (birthDate.length < 10) {
        this.ageErrors[`${planIndex}_${depIndex}_datanasc`] = false
        this.ageErrors[`${planIndex}_${depIndex}_idadecompat`] = false
        return
      }
      const isInvalidDate = !window.luxon.fromFormat(birthDate, 'dd/MM/yyyy').isValid
      this.ageErrors[`${planIndex}_${depIndex}_datanasc`] = isInvalidDate
      if (!isInvalidDate) {
        this.ageErrors[`${planIndex}_${depIndex}_idadecompat`] = !this.isAgeAllowed(planIndex, depIndex, birthDate)
      }
    },
    // TODO: Refactor
    showNextDep(idDep, btn){
      $('#'+btn).hide();
      $('#'+idDep).show();
    },
    async submit(store = true) {
      try {
        const inputs = Array.from(document.querySelectorAll("input, select"))

        const validations = []
        const keys = new Set(this.allDependents.map(dep => dep.key))
        const usedDocuments = []

        keys.forEach(async key => {
          const filteredInputs = inputs.filter(input => input.name.includes(key))
          const names = filteredInputs.map(input => input.name)
          const values = filteredInputs.map(input => input.value)
          const cpfInput = filteredInputs.find(input => input.name.includes('cpf'))

          if (cpfInput.disabled) {
            validations.push(true);
          } else {
            if ((new Set(values)).size === 1) {
              validations.push(new Promise((resolve, _) => resolve(true)))
            } else {
              if (cpfInput.value.length < 14) {
                let message = ''
                if (cpfInput.value.length === 0) message = 'O campo deve ser preenchido.'
                else if (!ValidaCPF(cpfInput.value)) message = 'Informe um CPF válido.'
                this.setValidationError(cpfInput.name, message)
                validations.push(false)
              } else if (!ValidaCPF(cpfInput.value)) {
                let message = 'Informe um CPF válido.'
                this.setValidationError(cpfInput.name, message)
                validations.push(false)
              } else if (usedDocuments.includes(cpfInput.value)) {
                let message = 'CPF já cadastrado em outro dependente.'
                this.setValidationError(cpfInput.name, message)
                validations.push(false)
              }
              validations.push(this.$validator.validateAll(names))
              usedDocuments.push(cpfInput.value)
            }
          }
        })
        
        const result = await Promise.all(validations)

        if (result.includes(false)) {
          throw new Error('Preencha os campos corretamente.')
        }

        if (store) {
          return await this.storeDependents()
        } else {
          return true
        }
      } catch (error) {
        console.log(error)
        if (document.querySelector("#cadastroSocio")) {
          $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing')
        }

        return false
      }
    },
    setValidationError(field, msg) {
      this.$validator.errors.add({
        field: field,
        msg: msg
      })
    },
    removeCPFError(inputName) {
      this.errors.remove(inputName)
    },
    // Não faço a menor ideia do que isso faz, originalmente foi escrito pelo David Petter.
    onDeleteMask(event) {
      let value = event.target.value; 
      let char = value[value.length-1];
      if (isNaN(parseInt(char)) || char == ' ') { event.target.value = value.substring(0, value.length-1); }
    },
    async storeDependents() {
      this.error.show = false
      this.$validator.errors.clear()

      try {
        const response = await axios.post('/cadastro/dependentes', {
          userId: this.user.id,
          dependentes: this.dependentes
        })

        const { data } = response

        if(data.error) {
          if (document.querySelector("#cadastroSocio")) {
            $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing');
          }

          if(typeof data.message == "string") {
            this.error.show = true
            this.error.text = data.message
          } else {
            $.each(data.message, function( indexPlano, valuePlanp ) {
              $.each(valuePlanp, function( index, fields) {
                $.each(fields, function( campo, mensagem) {
                  const field = campo + '_' + indexPlano + '_' + index;
                  this.setValidationError(field, mensagem)
                })
              })
            })
          }

          return false
        } else {
          // get rid of null ids before updating _the carrinho_
          const results = data.data
          results.forEach(result => {
            const dep = this.allDependents.find(dep => dep.cpf.replace(/[^0-9]/g, '') === result.cpf)
            if (dep) {
              dep.id = result.id
            }
          })

          if (this.plano.id === 980 || this.plano.id === 981) {
            window.location.href = 'https://somoslusafree.fansurvey.com.br/cadastro'
            return true
          }

          if(response.data.login) {
            window.location.href = "/login";
            return true
          }
        }
        return true
      } catch (error) {
        $( ".wizard-footer-right" ).show();

        this.error.show = true

        if (typeof error.response.data.errors.email[0] !== 'undefined') {
          this.error.text = error.response.data.errors.email[0]
        } else {
          this.error.text = "Erro interno, tente novamente mais tarde."
        }

        return false
      }
    }
  }
})
</script>
